import type { OrdTypeEnum, PresenceEnum } from './types';

// These "Like" interfaces are used in Kyoko components that use both Principal+Whitelabel Strategy Params
export interface ParameterLike {
  DisplayName: string;
  Name: string;
  Type: ParameterTypeEnum;
  Presence: PresenceEnum;
  Description: string;
  DefaultValue?: string;
  EnumValues?: EnumParameter[];
}

export interface EnumParameter {
  Index: number;
  Name: string;
  Description: string;
}

export interface StrategyLike {
  Name: string;
  DisplayName: string;
  Parameters: ParameterLike[];
  Group?: string;
  Description?: string;
  OrdType?: OrdTypeEnum;
}

export enum ParameterTypeEnum {
  Aggregation = 'Aggregation',
  Bps = 'Bps',
  Date = 'Date',
  Duration = 'Duration',
  Enum = 'Enum',
  Integer = 'Integer',
  Interval = 'Interval',
  JSON = 'JSON',
  Mode = 'Mode',
  Percent = 'Percent',
  Price = 'Price',
  PriceOffset = 'PriceOffset',
  PriceProtection = 'PriceProtection',
  PriceReferenceType = 'PriceReferenceType',
  Qty = 'Qty',
  ReduceFirst = 'ReduceFirst',
  ReduceOnly = 'ReduceOnly',
  String = 'String',
  Symbol = 'Symbol',
  HedgeStrategy = 'HedgeStrategy',
  TargetParticipationRate = 'TargetParticipationRate',
  UnifiedLiquidity = 'UnifiedLiquidity',
  Units = 'Units',
}
